import { render } from "./ShareButton.vue?vue&type=template&id=1a0de751&ts=true"
import script from "./ShareButton.vue?vue&type=script&lang=ts"
export * from "./ShareButton.vue?vue&type=script&lang=ts"

import "./ShareButton.vue?vue&type=style&index=0&id=1a0de751&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__